import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ScaleStore } from '../../scale.store';
import { EndPoint, getEndpoint } from 'src/app/models/endpoint';
import { LoadingService } from '../../loading.service';
import { AuthStore } from '../../auth.store';
import { SugestaoService } from './sugestao.service';

@Injectable()
export class SugestaoHttpService extends SugestaoService {
  constructor(
    private http: HttpClient,
    scaleStore: ScaleStore,
    private loadingService: LoadingService,
    private authStore: AuthStore
  ) {
    super(scaleStore);
  }

  //Add Loading

  public override sugerirRegraPost(
    sugestao: String,
    escalaId: number
  ): Observable<any> {
    this.loadingService.presentLoading();
    return this.http
      .post(`${getEndpoint(EndPoint.ESCALA)}/regras-sugestao`, {
        sugestao,
        userId: this.authStore.getUser().id!,
        escalaId,
      })
      .pipe(
        catchError((err: any) => {
          this.loadingService.dismissLoading();
          if (err.error.message) {
            this.loadingService.presentToast(err.error.message, 'danger');
          } else {
            const message = 'Erro ao salvar sugestão';
            this.loadingService.presentToast(message);
          }

          return throwError(err);
        }),
        tap((r) => {
          console.log(r);
          this.loadingService.dismissLoading();
        })
      );
  }

  public override carregaRegrasSugeridasGet(): Observable<any> {
    this.loadingService.presentLoading();
    return this.http
      .get(
        `${getEndpoint(
          EndPoint.ESCALA
        )}/regras-sugestao/${this.authStore.getAdminId()}`
      )
      .pipe(
        catchError((err: any) => {
          this.loadingService.dismissLoading();
          if (err.error.message) {
            this.loadingService.presentToast(err.error.message, 'danger');
          } else {
            const message = 'Erro ao carregar regras sugerias';
            this.loadingService.presentToast(message);
          }
          return throwError(err);
        }),
        tap((r) => {
          this.loadingService.dismissLoading();
        })
      );
  }

  public override carregaRegrasSugeridasByEscalaId(
    escalaId: number
  ): Observable<any> {
    this.loadingService.presentLoading();
    return this.http
      .get(`${getEndpoint(EndPoint.ESCALA)}/regras-sugestao/escala/${escalaId}`)
      .pipe(
        catchError((err: any) => {
          this.loadingService.dismissLoading();
          if (err.error.message) {
            this.loadingService.presentToast(err.error.message, 'danger');
          } else {
            const message = 'Erro ao carregar regras sugerias';
            this.loadingService.presentToast(message);
          }
          return throwError(err);
        }),
        tap((r) => {
          this.loadingService.dismissLoading();
        })
      );
  }
}
